"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/ui/icon";
import { Toaster as Sonner } from "sonner";
import { useTheme } from "next-themes";
const Toaster = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const t2 = theme;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      classNames: {
        toast: "group toast  group-[.toaster]:bg-white group-[.toaster]:text-slate-12 group-[.toaster]:border-slate-6 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-slate-3",
        title: "font-normal",
        description: "font-normal group-[.toast]:text-slate-10",
        actionButton: "group-[.toast]:bg-slate-9 group-[.toast]:text-slate-12",
        cancelButton: "group-[.toast]:bg-slate-3 group-[.toast]:text-slate-11"
      }
    };
    t4 = {
      info: <Icon icon="lucide:info" className="h-4 w-4 text-blue-9" />,
      success: <Icon icon="lucide:check-circle" className="h-4 w-4 text-green-9" />,
      warning: <Icon icon="lucide:alert-triangle" className="h-4 w-4 text-amber-9" />,
      error: <Icon icon="lucide:x-circle" className="h-4 w-4 text-red-9" />
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== props || $[5] !== t2) {
    t5 = <Sonner theme={t2} className="toaster group" toastOptions={t3} icons={t4} {...props} />;
    $[4] = props;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export { Toaster };